import { create } from 'zustand';

import { FORMS_FILE_UPLOAD_PATH } from 'services/forms';

export type WidgetConfigState = {
	baseApiUrl: string;
	widgetApiUrl: string;
	interactionUrl: string;
	imagePath: string;
	loginUrl: string;
	APIEndPoints: { [key: string]: string };
	googleMapsApiKey?: string;
	disableLive: boolean;
	login: () => void;
	hydrate: (config: {
		baseApiUrl: string;
		widgetApiUrl: string;
		interactionUrl: string;
		imagePath: string;
		loginUrl: string;
		APIEndPoints?: { [key: string]: string };
		googleMapsApiKey?: string;
	}) => void;
	setDisableLive: (disableLive: boolean) => void;
};

const defaultLogin = () => {
	const { loginUrl } = useWidgetConfigStore.getState();
	if (/(widget\/embed|\/embed)/.test(window.location.pathname)) {
		window.parent.postMessage(
			JSON.stringify({
				action: 'web30auth',
			}),
			'*'
		);
	} else {
		window.location.href = loginUrl;
	}
};

export const useWidgetConfigStore = create<WidgetConfigState>((set) => ({
	baseApiUrl: '',
	widgetApiUrl: '',
	interactionUrl: '',
	imagePath: '',
	loginUrl: '',
	APIEndPoints: {
		FileUpload: FORMS_FILE_UPLOAD_PATH,
	},
	googleMapsApiKey: undefined,
	disableLive: false,
	login: defaultLogin,
	hydrate: ({
		baseApiUrl,
		widgetApiUrl,
		interactionUrl,
		imagePath,
		loginUrl,
		APIEndPoints,
		googleMapsApiKey,
	}) => {
		const nextEndPoints = {
			FileUpload: FORMS_FILE_UPLOAD_PATH,
			...APIEndPoints,
		};
		const current = useWidgetConfigStore.getState();
		if (
			current.baseApiUrl === baseApiUrl &&
			current.widgetApiUrl === widgetApiUrl &&
			current.interactionUrl === interactionUrl &&
			current.imagePath === imagePath &&
			current.loginUrl === loginUrl &&
			current.googleMapsApiKey === googleMapsApiKey &&
			JSON.stringify(current.APIEndPoints) ===
				JSON.stringify(nextEndPoints)
		) {
			return;
		}
		set({
			baseApiUrl,
			widgetApiUrl,
			interactionUrl,
			imagePath,
			loginUrl,
			APIEndPoints: nextEndPoints,
			googleMapsApiKey,
			login: defaultLogin,
		});
	},
	setDisableLive: (disableLive) => set({ disableLive }),
}));
